export default __webpack_public_path__ + "static/media/34.fc073dbe.png";